export function Button({ children, ...props }) {
  return (
    <button
      className="px-4 py-2 bg-blue-500 text-white font-medium rounded-lg hover:bg-blue-600 transition"
      {...props}
    >
      {children}
    </button>
  );
}
